module.exports = __webpack_public_path__ + "img/brand-03.b97a86e2.png";